export default __webpack_public_path__ + "static/media/template_business-man__0020_7---yuLiang.dda56cdb.png";